'use strict';

const BaseDirective=require('../../../../dist-es6/client/angularCommon/baseDirective');let

CheckMarkDirective=class CheckMarkDirective extends BaseDirective{
get restrict(){
return'E';
}

get templateUrl(){
return'/templates/directives/checkMarkDirective/checkMarkTemplate';
}};


module.exports=CheckMarkDirective;
//# sourceMappingURL=checkMarkDirective.js.map
